import { render } from "./Notifiche.vue?vue&type=template&id=7e0d6627"
import script from "./Notifiche.vue?vue&type=script&lang=ts"
export * from "./Notifiche.vue?vue&type=script&lang=ts"
script.render = render

export default script